var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 109,
    viewBox: "0 0 108 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2427 2.17079C39.014 0.416287 41.4856 -0.20911 42.1189 1.44303L47.43 15.3033C54.288 33.2007 72.5165 44.0673 91.5216 41.5879L106.24 39.6678C107.995 39.439 108.62 41.9106 106.968 42.544L93.1074 47.8551C75.2102 54.7131 64.3436 72.9415 66.823 91.9467L68.7431 106.665C68.9719 108.42 66.5002 109.045 65.8669 107.393L60.5558 93.5324C53.6978 75.6352 35.4694 64.7687 16.4641 67.2481L1.74574 69.1682C-0.00876143 69.3969 -0.634158 66.9253 1.01798 66.292L14.8783 60.9809C32.7757 54.1228 43.6422 35.8944 41.1628 16.8891L39.2427 2.17079Z",
    fill: "#39DBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB3);
export default __webpack_public_path__ + "static/media/b3.2ecfd7d79a6a4499a66b3312b5564988.svg";
export { ForwardRef as ReactComponent };